
import { collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { db } from "./firabaseConfig";
import { instance } from "./mainAxios";
// import crypto from "crypto"
const mainPath = "/class"
// const getAllTeacherClasses = () => {
//     const path = mainPath + "/getTeacherClasses";

//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.get(path);
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
const getAllTeacherClasses = async (id) => {
    console.log("🚀 ~ file: classRequest.js:20 ~ getAllTeacherClasses ~ id:", id)
    try {//TODO: adding rule to prevent data leak
        const classRef = collection(db, "classes");
        let q = query(classRef, where("teacherId", "==", id));
        let classSnap = (await getDocs(q)).docs.map(doc => ({ ...doc.data(), id: doc.id }));
        if (classSnap.length) {
            let classes = transformStudentsToArray(classSnap)
            let sortByCreateDate = classes.filter((oneClass) => oneClass.isActive).sort((a, b) => a.create - b.create);
            return sortByCreateDate
        } else {
            return []
        }
    } catch (error) {
        console.log("🚀 ~ file: userRequests.js:58 ~ getUserDetails ~ error:", error)

    }

};

const getOneUserDetails = async (id) => {
    try {//TODO: adding rule to prevent data leak
        const userRef = doc(db, "users", id);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
            let user = docSnap.data()
            return { ...user, id: docSnap.id }
        } else {
            throw { message: "User dosnt found" }
        }
    } catch (error) {
        console.log("🚀 getUserDetails ~ error:", error)

    }
}
const getOneTeacherClasses = (class_id) => {
    const path = mainPath + "/getClass/" + class_id;

    return new Promise(async (resolve, reject) => {
        try {
            const res = await instance.get(path);
            resolve(res);
        } catch (error) {
            reject(error);
        }
    });
};

//Login
// const getNewClassId = () => {
//     const path = mainPath + "/generateClassId";
//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.get(path);
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
// const createNewClass = (classDetails) => {
//     console.log("🚀 ~ file: classRequest.js:81 ~ createNewClass ~ classDetails:", classDetails)
//     const path = mainPath + "/createClass";
//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.post(path, classDetails);
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
const createNewClass = async (classDetails) => {

    let newClassDetails = {
        classroomId: classDetails.classroomId,
        classroomName: classDetails.classroomName,
        isActive: true,
        students: [],
        teacherId: classDetails.teacherId,
        create: Date.now()

    }
    let newClassDoc = await setDoc(doc(db, "classes", classDetails.classroomId), newClassDetails);
    console.log("🚀 ~ file: classRequest.js:81 ~ createNewClass ~ classDetails:", classDetails)
    return false
};
// const editClassDetails = (classId, newClassDetails) => {
//     const path = mainPath + "/updateClassDeatils/" + classId;

//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.put(path, newClassDetails);
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
const editClassDetails = async (classId, newClassDetails) => {

    const cityRef = doc(db, 'classes', classId);
    let updateClassDetails = await setDoc(cityRef, { ...newClassDetails }, { merge: true });
    return updateClassDetails

};

const deleteClass = async (classId) => {

    const cityRef = doc(db, 'classes', classId);
    let updateClassDetails = await setDoc(cityRef, { isActive: false }, { merge: true });
    return updateClassDetails
};

function transformStudentsToArray(classData) {
    return classData.map((classItem) => {
        const studentsArray = Object.keys(classItem.students).map((studentId) => {
            const student = classItem.students[studentId];
            return {
                id: studentId,
                firstName: student.firstName,
                lastName: student.lastName,
                TR: student.TR,
                TF: student.TF,
                asses: student.asses,
            };
        });

        return {
            classroomName: classItem.classroomName,
            isActive: classItem.isActive,
            teacherId: classItem.teacherId,
            classroomId: classItem.classroomId,
            create: classItem.create,
            students: studentsArray,
            id: classItem.id,
        };
    });
}



const generateClassId = (length = 6) => {
    const charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        result += charset[randomIndex];
    }
    return result;

};

const getNewClassId = async () => {
    let classroomId = "";
    let validatedAsUnique = false;
    let maxTrys = 100;
    let trysCounter = 0;
    while (!validatedAsUnique) {
        classroomId = generateClassId();
        if (trysCounter >= maxTrys) {
            classroomId = false;
            validatedAsUnique = true;
        }
        let alreadyExicst = false;
        const docRef = doc(db, "classes", classroomId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            alreadyExicst = true
        } else {
            // docSnap.data() will be undefined in this case
        }
        if (!alreadyExicst) {
            validatedAsUnique = true;
        }
        trysCounter++;
    }
    return classroomId;
};
//
//
const classRequets = { getOneUserDetails, getAllTeacherClasses, getNewClassId, createNewClass, editClassDetails, deleteClass, getOneTeacherClasses };
export default classRequets;
